import templateUrl from 'emun.on-demand/media/od-media-manager.htm'
import resolve from 'ioc/resolve'
import basicController from 'servicestack/basic.controller.properties'
import addMediaPrompt from 'emun.on-demand/media/add-media-prompt'
import editMediaPrompt from 'emun.on-demand/media/edit-media-prompt'
import extendDesignPrompt from 'emun.on-demand/media/extend-design-prompt'
import ServiceBus from 'servicestack/service-bus'
import AutoQuery from 'servicestack/auto-query/auto-query'
import Media from 'webutils/media/media'
import CreateMedia from 'emun.on-demand/lib/create-media'
import modals from 'webmodals/modals'

class MediaManagerController {
    constructor($state, $stateParams) {
        basicController(this)
        const $ctrl = this;
        Object.assign($ctrl, {$state}, $stateParams);
        let criteria = Object.assign({
            active:true,
            //contentTypeStartsWith:$stateParams.context==='publish'?'image':null,
        }, $stateParams,{
            context: $stateParams.context || 'Designer'
        });
        $ctrl.bus = new ServiceBus();
        $ctrl.navs = $state.getNav('od-media');
        $ctrl.panelType = 'default';

        let options = {
            pageSize: 24,
            tagTotalsUrl: 'QueryMediaTagTotals.json?Context=' + criteria.context,
            url: `QueryMedia.json?Context=${criteria.context}&Fields=Id,Label,Description,Tags,Url,CreatedOn,Active,Euid,Realm,ContentType,Height,Width`,
            orderBy: '-CreatedOn,Id',
            autoLoad: true,
            append: false,
            hideLeftNav: true,
            navs: [],
            filters:[
                {text:'Search',operation:''},
                {tag:'Content Type', hidden: true},
                {tag:'Image Type', hidden: true},
            ],
            criteria,
            scrub(response) {
                response.data.results = response.data.results.map(m => new Media(m));
            },
            sortOptions: {
                'Id': 'Id',
                '-Id': 'Id',
                'Label': 'Label',
                '-Label': 'Label',
                'ContentLength': 'Size',
                '-ContentLength': 'Size',
                'Description': 'Description',
                '-Description': 'Description',
                'Rating': 'Rating',
                '-Rating': 'Rating',
                'CreatedOn,Id': 'Created',
                '-CreatedOn,Id': 'Created',
                'Active': 'Active',
                '-Active': 'Active',
            }
        }

        $ctrl.query = new AutoQuery(options);
        if($stateParams.add){
            $ctrl.addMedia();
        }
        //});
    }

    upload($files) {
        let $ctrl = this;
        if($files && $files.length) {
            let req = {
                tags: $ctrl.query.getTagCriteria()
            };
            var cm = $ctrl.createMedia = new CreateMedia($files, req);
            cm.all.finally(() => $ctrl.createMedia = !$ctrl.query.load(true));
        }
    }

    addMedia() {
        const $ctrl = this;
        return addMediaPrompt({}).then(result => {
            if($ctrl.add){
                if(result.media && result.media.length){
                    $ctrl.publish(result.media[0]);
                }
            }else{
                $ctrl.query.load(true);
            }
        });
    }

    editMediaInfo(media) {
        const $ctrl = this;
        return editMediaPrompt({
            subTitle: media && media.label,
            media
        }).then(result => {
            if(result){
                if(result.updated) Object.assign(media, result.updated);
                if(result.regenerateDesign) $ctrl.regenerateDesign(result.regenerateDesign);
                if(result.extendDesign) $ctrl.extendDesign(result.extendDesign);
                if(result.publish) $ctrl.publish(result.publish);
                if(result.toggleMedia) $ctrl.toggleMedia(result.toggleMedia);
            }            
        });
    }

    extendDesign(design) {
        const $ctrl = this;
        return extendDesignPrompt({
            subTitle: design && design.label,
            design
        }).then(result => Object.assign(design, result));
    }

    publish(media) {
        const $ctrl = this;
        $ctrl.$state.transitionTo("od-publish", {designId:media.id});
    }

    filterStatus(active) {
        const $ctrl = this;
        $ctrl.query.criteria.active = active;
        $ctrl.query.load(true);
    }

    statusLabel(active) {
        return active === true ? 'Active' : active === false ? 'Inactive' : 'All'
    }

    regenerateDesign(m) {
        const $ctrl = this;
        const $cart = resolve('$cart');  //smelly
        let url = `CreateDesign.json`;
        let req = Object.assign({json:m.designUrl()}, m);
        if($cart.businessModel === 'Wholesale' && $cart.purchaser)
            req.tags['$RetailerId'] = [$cart.purchaser.id]; 
        $ctrl.bus.send(url, req).then(res => Object.assign(m, res.data)); //$ctrl.query.load(true)
    }

    deleteMedia(media) {
        const $ctrl = this;
        return modals.confirm('Delete media', media.label).result.then(() => {
            return $ctrl.bus.send('DeleteMedia.json', media).then(res => $ctrl.query.load(true));
        });    
    }

    toggleMedia(m, skip, activated) {
        const $ctrl = this;
        if( activated !== true && activated !== false) activated = !m.active;
        let url = `${m.active?'Dea':'A'}ctivateMedia/${m.id}.json`;
        m.active = activated;
        m.status = activated ? 'Active' : 'Inactive';

        $ctrl.bus.send(url).then(res => Object.assign(m, res.data)); //$ctrl.query.load(true)
    }

    toggleAllMedia(activated) {
        let $ctrl = this;
        $ctrl.query.results.forEach(p => $ctrl.toggleMedia(p, true, activated));
    }

    addTags() {
        return modals.alert('This feature has not been implemented as of yet.', 'Under Construction');
    }

    $onDestroy() {
        this.query.dispose();
    }
}

export default MediaManagerController;